import { useApi } from '@backstage/core-plugin-api';
import { useAsync } from 'react-use';
import { devOpsMetricsApiRef, DevOpsMetricsQueryParams, TimeToMarketScoreResponse } from '../api';

export function useTimeToMarketScore(params: DevOpsMetricsQueryParams) {
  const devOpsMetricsApi = useApi(devOpsMetricsApiRef);

  const {
    value: data,
    loading,
    error,
  } = useAsync(async (): Promise<TimeToMarketScoreResponse | undefined> => {
    if (!params.entityRef && !params.repoUrl) {
      return undefined;
    }
    return devOpsMetricsApi.getTimeToMarketScore(params);
  }, [devOpsMetricsApi, params.entityRef, params.repoUrl, params.dateFrom, params.dateTo, params.platformCode, params.portfolio, params.beatId, params.beatName, params.ghaName, params.ghaEnvironment]);

  return {
    data,
    loading,
    error,
  };
}
